import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.43 14.74H4.57a3.32 3.32 0 0 1-3.31-3.32V4.57a3.32 3.32 0 0 1 3.31-3.32h6.86a3.32 3.32 0 0 1 3.32 3.32v6.85a3.32 3.32 0 0 1-3.32 3.32Zm-6.86-12a1.81 1.81 0 0 0-1.81 1.83v6.85a1.81 1.81 0 0 0 1.81 1.82h6.86a1.82 1.82 0 0 0 1.82-1.82V4.57a1.82 1.82 0 0 0-1.82-1.82Z';
const draw24px =
  'M16.57,20.75H7.43a4.18,4.18,0,0,1-4.18-4.18V7.43A4.18,4.18,0,0,1,7.43,3.25h9.14a4.18,4.18,0,0,1,4.18,4.18v9.14A4.18,4.18,0,0,1,16.57,20.75Zm-9.14-16A2.68,2.68,0,0,0,4.75,7.43v9.14a2.68,2.68,0,0,0,2.68,2.68h9.14a2.68,2.68,0,0,0,2.68-2.68V7.43a2.68,2.68,0,0,0-2.68-2.68Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const CheckboxUncheckedIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'checkboxUnchecked')) as IconWithRender;

CheckboxUncheckedIcon.displayName = 'CheckboxUncheckedIcon';
CheckboxUncheckedIcon.propTypes = Icon.propTypes;
CheckboxUncheckedIcon.renderIcon = (props) => (
  <CheckboxUncheckedIcon {...props} />
);
export default CheckboxUncheckedIcon;
